import { useRef, useState, useEffect } from 'react';

export function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({ width: +window.innerWidth, height: +window.innerHeight });
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowSize;
}

export const useEvent = (func: Function) => {
	const funcRef = useRef(func);

	const staticFuncRef = useRef((...args: any) => funcRef.current(...args));

	funcRef.current = func;

	return staticFuncRef.current;
}
